module.exports = __webpack_public_path__ + "assets/images/compass.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/compass.png
// module id = 1513
// module chunks = 1